// src/utils/api.js

const API_VERSION = "/v1";   // ← Change to /v2 later with ONE update

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

if (!BASE_URL) {
  console.error("❌ REACT_APP_BACKEND_URL is not set!");
}

export async function apiPost(endpoint, payload) {
  const url = `${BASE_URL}${API_VERSION}${endpoint}`;

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      let body = {};
      try { body = await res.json(); } catch {}
      throw new Error(body.detail || `Request failed (${res.status})`);
    }

    return await res.json();
  } catch (err) {
    console.error(`❌ API POST Error at ${url}:`, err.message);
    throw err;
  }
}

export async function apiGet(endpoint) {
  const url = `${BASE_URL}${API_VERSION}${endpoint}`;

  try {
    const res = await fetch(url);

    if (!res.ok) {
      let body = {};
      try { body = await res.json(); } catch {}
      throw new Error(body.detail || `Request failed (${res.status})`);
    }

    return await res.json();
  } catch (err) {
    console.error(`❌ API GET Error at ${url}:`, err.message);
    throw err;
  }
}
